import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 路由懒加载
const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
const About = () => import(/* webpackChunkName: "about" */ '../views/About.vue')
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
const AICreation = () => import(/* webpackChunkName: "ai-creation" */ '../views/AICreation.vue')
const Review = () => import(/* webpackChunkName: "review" */ '../views/Review.vue')
const Publish = () => import(/* webpackChunkName: "publish" */ '../views/Publish.vue')
const Purchase = () => import(/* webpackChunkName: "purchase" */ '../views/Purchase.vue')
const Order = () => import(/* webpackChunkName: "order" */ '../views/Order.vue')

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '登录',
        requiresAuth: false
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        title: '关于',
        requiresAuth: false
      }
    },
    {
      path: '/dashboard',
      redirect: '/dashboard/ai-creation',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'ai-creation',
          name: 'AICreation',
          component: AICreation,
          meta: {
            title: 'AI创作',
            requiresAuth: true
          }
        },
        {
          path: 'review',
          name: 'Review',
          component: Review,
          meta: {
            title: '草稿审核',
            requiresAuth: true
          }
        },
        {
          path: 'publish',
          name: 'Publish',
          component: Publish,
          meta: {
            title: '发布管理',
            requiresAuth: true
          }
        },
        {
          path: 'purchase',
          name: 'Purchase',
          component: Purchase,
          meta: {
            title: '购买套餐',
            requiresAuth: true
          }
        },
        {
          path: 'order',
          name: 'Order',
          component: Order,
          meta: {
            title: '我的订单',
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// 全局导航守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title + ' - EasyPost'
  }
  
  // 检查是否需要登录
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  
  if (requiresAuth) {
    // 检查是否有token
    const token = localStorage.getItem('token')
    if (!token) {
      // 没有token，重定向到登录页
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
      return
    }
  }
  
  next()
})

// 路由错误处理
router.onError((error) => {
  console.error('Router error:', error)
})

export default router
